<div dropdown class="dropdown" keyboard-nav="true">
  <button
    dropdownToggle
    class="btn btn-default columns dropdown-toggle shrink qa-resource-type-filter__dropdown"
    data-bs-toggle="dropdown"
    type="button"
    [tooltip]="resourceTypeFilterTooltipTemplate"
    [isDisabled]="!isFilterLabelTruncated"
    placement="bottom"
    rlElementOverflowListener
    (elementTruncated)="onFilterLabelTruncate($event)"
    [elementSelector]="'.filter-menu__label--truncated'"
  >
    <span class="filter-menu__label--truncated">
      <ng-container [ngSwitch]="resourceTypeFilter ? true : false">
        <ng-container
          *ngSwitchCase="true"
          i18n="@@resourceTypeFilterMenu-label-filteredResourceType"
        >
          Type:
          <rl-bibliographic-resource-type
            [resourceType]="resourceTypeFilter.value"
          ></rl-bibliographic-resource-type>
        </ng-container>
        <ng-container *ngSwitchDefault i18n="@@resourceTypeFilterMenu-label-all"
          >Type: All</ng-container
        >
      </ng-container>
    </span>
  </button>

  <ng-template #resourceTypeFilterTooltipTemplate>
    <ng-container [ngSwitch]="resourceTypeFilter ? true : false">
      <rl-bibliographic-resource-type
        *ngSwitchCase="true"
        [resourceType]="resourceTypeFilter.value"
      >
      </rl-bibliographic-resource-type>
      <ng-container *ngSwitchDefault i18n="@@resourceTypeFilterMenu-tooltip-all"
        >All</ng-container
      >
    </ng-container>
  </ng-template>

  <ul class="dropdown-menu" *dropdownMenu>
    <li>
      <button
        (click)="onClearAll($event)"
        class="dropdown-item filter-menu__button qa-resource-type-filter--remove-all"
        type="button"
      >
        <ng-container i18n="@@resourceTypeFiltersMenu-btn-removeAll">
          All
        </ng-container>
        <span class="filter-menu__item-count">
          {{ itemCount?.totalItems }}</span
        >
      </button>
    </li>

    <li class="dropdown-divider" role="presentation"></li>

    <li *ngFor="let resourceType of resourceTypes">
      <button
        class="dropdown-item"
        [ngClass]="['filter-menu__button', 'qa-resource-type--' + resourceType]"
        type="button"
        (click)="onFilterByResourceType(resourceType)"
      >
        <rl-bibliographic-resource-type
          [resourceType]="resourceType"
          class="pull-left"
        >
        </rl-bibliographic-resource-type>
        <span class="filter-menu__item-count">{{
          itemCount?.itemCountByResourceType.get(resourceType, 0)
        }}</span>
      </button>
    </li>
  </ul>
</div>
